import { useTranslation } from "next-i18next";
import { ErrorCommon } from "src/components/pages/error/common";
import { Typography } from "src/components-mui/base/typography/typography";

const ERROR_404_TEXT_TEST_ID = "error-404-text";

export const Error404 = () => {
    const { t } = useTranslation("common");

    return (
        <ErrorCommon subHeadline={t("errors.pages.404")}>
            <Typography
                component="p"
                data-test-id={ERROR_404_TEXT_TEST_ID}
                sx={{
                    mt: 2,
                    fontSize: ["lg", "xl"],
                    textAlign: ["center", "center", "unset"],
                }}
            >
                {t("errors.messages.404.heading")}
                <br />
                {t("errors.messages.404.message")}
            </Typography>
        </ErrorCommon>
    );
};
